import type { FaireProductEntity } from "../../entity_types/product";

export const p_yvursdwjnq: FaireProductEntity = {
  token: "p_yvursdwjnq",
  type: "product",
  name: "Lavender Dreams - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/b6ba84f6c0133e357da1380cbc3bca642882083efafafda8fdcf1056ad3656e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1fd1299c4e8c64124095022ebeddd2dea474ee66a4ba95480fed0238dcc2a6e4.jpeg",
    "https://cdn.faire.com/fastly/806b02d09b75a398c6367890dbec93e0c7641ce26763e6cdcab359ecadf10787.png",
    "https://cdn.faire.com/fastly/6ee4a245ff771a6b6dcdd607a0d12fd6533249232ee324d202ff765fcd8b7841.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nClean linens, soft slippers and a cozy cup of lavender tea: a few of our favourite things about bedtime! Sip and soak up a little relaxation with this soothing blend of lavender, passionflower, and superfoods tulsi and ashwagandha. It’s perfect to soothe your nerves on a stressful day, or as a part of your nightly wind-down ritual.\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * During your slow morning ritual. \n * Mid-day to slow down and sip in mindfulness. \n * After dinner to wind down and ease digestion. \n * Before bed to promote sleep. \n\nCaffeine-free\n\n\n\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:38.537Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
